import cx from "classnames";
import { Remarkable } from "remarkable";
import TurndownService from "turndown";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Suspense, useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../../hooks/redux.hook";
import { UserService } from "../../../_service";
import I18 from "../../../_components/atoms/i18";
import { Button, ErrorDiv, Loader, TextInput } from "../../../_components";
import { Tick } from "../../../_components/form-controls/tick-component";
import { debounce } from "lodash";
import RichTextEditor from "../../../_components/form-controls/rich-text-editor.component";
import { PictureUpdate } from "../../../_components/profile/profile-update.component";
import { useAppService } from "../../../hooks/use-app-service";
import { withToast } from "../../../contexts/toastr.context";
import { createSession } from "../../../_store/_actions/auth.actions";
interface Props {
    editProfile: boolean
    selectedUser: any
    setUser: (user: any) => void;
    addToast: any;
}
function EditProfileModal({
    editProfile,
    selectedUser,
    setUser,
    addToast
}: Props) {
    const tds = new TurndownService();
    const { analyticsService } = useAppService();

    const { user, community } = useAppSelector((s) => ({
        user: s.auth,
        community: s.community,
    }));
    const isUserNotNew = selectedUser?.name !== "New User";

    const [userId, setUserId] = useState("");
    const [name, setName] = useState("");
    const [bio, setBio] = useState("");
    const [picture, setPicture] = useState("");
    const [shortBio, setShortBio] = useState("");
    const [userIdAvailable, setUserIdAvailable] = useState(true);
    const [isCheckingForAvailability, setIsCheckingForAvailability] =
        useState(false);
    const [isFormSubmittable, setIsFormSubmittable] = useState(
        isUserNotNew ? true : false
    );
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    const md = new Remarkable();

    useEffect(() => {
        setName(isUserNotNew ? selectedUser.name : "");
        setShortBio(isUserNotNew ? selectedUser.shortBio : "");
        setName(isUserNotNew ? selectedUser.name : "");
        setShortBio(isUserNotNew ? selectedUser.shortBio : "");
        setBio(selectedUser.bio ? md.render(selectedUser.bio) : "");
        setUserId(selectedUser.userId ? selectedUser.userId : "");
        setUserIdAvailable(selectedUser.userId);
        setPicture(selectedUser.picture);
    }, [selectedUser]);

    // debounced check for userId availability
    const checkForAddressAvailability = useCallback(
        debounce((userId) => {
            console.log(userId)
            // if userId is
            if (/^[A-Za-z0-9_.]{3,63}$/.test(userId)) {
                setIsCheckingForAvailability(true);
                // check for address
                UserService.checkForUserIdAvailability(userId, user)
                    .then(({ userIdAvailable }) => {
                        // set if the address is available
                        setUserIdAvailable(userIdAvailable);
                        setIsCheckingForAvailability(false);
                    })
                    .catch((error) => {
                        console.log({ error });
                        setUserIdAvailable(false);
                        setIsCheckingForAvailability(false);
                    });
            }
        }, 1000),
        []
    );
    return (
        <div className="p-4">
            <PictureUpdate
                //@ts-ignore
                picture={picture}
                //@ts-ignore
                setPicture={setPicture}
                isUserNotNew={isUserNotNew}
                name={name}
                editProfile={editProfile}
            />
            <div className="mt-4 font-semibold text-secondary-foreground/85">
                <span>
                    <I18>
                        Your name
                    </I18>
                </span>
            </div>
            <TextInput
                placeholder="Name"
                validator={(value) => {
                    if (value.length < 2) {
                        setIsFormSubmittable(false);
                        return "Name invalid!";
                    } else if (value.length > 50) {
                        setIsFormSubmittable(false);
                        return "Name should be less than 50 characters";
                    } else {
                        setIsFormSubmittable(true);
                    }
                }}
                defaultValue={name}
                noBorder
                className="mb-1 border border-border bg-background py-2 focus:outline-none"
                onChange={(value) => {
                    setName(value);
                }}
                disabled={
                    isUserNotNew &&
                    !(community.myRole === "admin")
                }
            />
            <div className="mt-4 flex items-end gap-2">
                <span className="font-semibold text-secondary-foreground/85">
                    <I18>Subtitle</I18>
                </span>
                <span className="text-xxs font-normal text-secondary-foreground/80">
                    <I18>
                        (Max char 60)
                    </I18>
                </span>
            </div>
            <TextInput
                placeholder="Subtitle"
                validator={(value) => {
                    if (value.length < 2) {
                        setIsFormSubmittable(false);
                        return "Subtitle should be more than 2 characters";
                    } else if (value.length > 60) {
                        setIsFormSubmittable(false);
                        return "Subtitle should be less than 60 characters";
                    } else {
                        setIsFormSubmittable(true);
                    }
                }}
                defaultValue={shortBio}
                noBorder
                className="mb-1 border border-border bg-background py-2 focus:outline-none"
                onChange={(value) => {
                    setShortBio(value);
                }}
            />
            <div className="mt-4 flex items-center font-semibold text-secondary-foreground/85">
                <span>
                    <I18>User Id</I18>
                </span>
                <div className="ml-4 flex items-center">
                    {isCheckingForAvailability ? (
                        <Loader />
                    ) : (
                        <span className="py-1">
                            <Tick success={userIdAvailable} />
                        </span>
                    )}
                </div>
            </div>
            <TextInput
                placeholder="User Id (Username)"
                validator={(value) => {
                    if (value.length < 5) {
                        setIsFormSubmittable(false);
                        return "User id invalid!";
                    } else {
                        setIsFormSubmittable(true);
                    }
                    return undefined;
                }}
                noBorder
                defaultValue={userId}
                className="border border-border bg-background py-2 focus:outline-none"
                inputHolderClassName={cx({
                    " border-red-500": !userIdAvailable,
                    " border-green-500": userIdAvailable,
                })}
                onChange={(value) => {
                    setUserId(value);
                    if (value.length > 2) {
                        if (!isCheckingForAvailability)
                            setIsCheckingForAvailability(true);
                    } else {
                        setIsCheckingForAvailability(false);
                    }
                    checkForAddressAvailability(value);
                }}
                disabled={
                    isUserNotNew &&
                    !(community.myRole === "admin")
                }
            />
            <div className="mt-4 font-semibold text-secondary-foreground/85">
                <I18>Short Bio</I18>
            </div>
            <Suspense fallback={<></>}>
                <RichTextEditor
                    text={bio}
                    setText={setBio}
                    uploadImage={false}
                    //@ts-ignore
                    insertTable={false}
                    className="bg-background"
                />
            </Suspense>
            <Button
                disabled={!isFormSubmittable}
                className="w-full items-center py-2 mt-4"
                onClick={async () => {
                    setIsLoading(true);
                    const embedLessBio = await bio.replace(
                        /(?:<figure class="media"><oembed url=")([^"^<^>^\[^\]]+)(?:"><\/oembed><\/figure>)/g,
                        " $1 "
                    );
                    let finalBio = await tds.turndown(embedLessBio);

                    UserService.updateProfile(user, selectedUser?.id, {
                        name,
                        shortBio,
                        userId,
                        bio: finalBio,
                    })
                        .then((response) => {
                            if (
                                picture &&
                                typeof picture === "string" &&
                                picture.startsWith("http")
                                
                            ) {
                                console.log("hey")
                                setIsLoading(false);
                                setUser({
                                    ...selectedUser,
                                    name: response.user.name,
                                    bio: response.user.bio,
                                    shortBio: response.user.shortBio,
                                });

                                window.location.reload()
                                addToast("Profile Updated!");

                            } else if (!picture) {
                                UserService.deleteProfilePicture(user, selectedUser?.id)
                                    .then((response) => {
                                        setIsLoading(false);
                                        setUser({
                                            ...selectedUser,
                                            name: response.user.name,
                                            bio: response.user.bio,
                                            shortBio: response.user.shortBio
                                        });
                                        setPicture(response.user.picture);
                                        console.log(selectedUser)
                                        console.log(response.user.picture)
                                        window.location.reload();
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                    });
                            } else {
                                UserService.updatePicture(user, picture, selectedUser?.id)
                                    .then((response) => {
                                        setIsLoading(false);
                                        setUser({
                                            ...selectedUser,
                                            name: response.user.name,
                                            bio: response.user.bio,
                                            shortBio: response.user.shortBio
                                        });
                                        window.location.reload()

                                        // mix panel tracking
                                        analyticsService.track("profile-details", {
                                            profilePic: picture,
                                            bio: bio,
                                            name: name,
                                            socialhandles: JSON.stringify({
                                            }),
                                        });
                                    })
                                    .catch((error) => {
                                        if (
                                            error &&
                                            error.response &&
                                            error.response.data.message
                                        ) {
                                            setErrorMessage(
                                                error.response.data.errors.file[0]
                                            );
                                        }
                                        setIsLoading(false);

                                        // mix panel tracking
                                        analyticsService.track("profile-details", {
                                            profilePic: picture,
                                            bio: bio,
                                            socialhandles: JSON.stringify({
                                            }),
                                        });
                                    });
                            }
                        })
                        .catch((error) => {
                            if (
                                error &&
                                error.response &&
                                error.response.data.message
                            ) {
                                if (error.response.data.errors.name) {
                                    setErrorMessage(error.response.data.errors.name[0]);
                                }
                                if (error.response.data.errors.userId) {
                                    setErrorMessage(
                                        error.response.data.errors.userId[0]
                                    );
                                    setUserIdAvailable(false);
                                }
                            }
                            setIsLoading(false);
                        });
                }}
                isLoading={isLoading}
                label="Update"
            />
            <ErrorDiv error={errorMessage} />
        </div>
    )
}

const EditProfile = withToast(
    connect(
        (s: any) => ({
            user: s.auth,
            community: s.community,
        }),
        (d: any) =>
            bindActionCreators(
                {
                    setUser: createSession,
                },
                d
            )
    )(EditProfileModal)
);
export default EditProfile;
